module.exports = __webpack_public_path__ + "static/media/visualizacion-logo-caracol-tv-1969-1979@3x.8cf988d8.png";